export type ReloadFormStackContext = {
  pageDataSlot?: string
  formId?: string | number
  sessionId?: string | number
  source?: string
  eventCoreId?: string | number
}

export function isReloadFormStackContext(value: unknown): value is ReloadFormStackContext {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return false
  const o = value as Record<string, unknown>
  if ('fields' in o) return false
  if (o.pageDataSlot != null && String(o.pageDataSlot).trim() !== '') return true
  if (typeof o.source === 'string' && o.source.includes('reloadForm')) return true
  const keys = Object.keys(o)
  if (keys.length > 8) return false
  return o.formId != null || o.sessionId != null || o.eventCoreId != null
}

export function resolveReloadFormStackContext(
  dataOrContext?: unknown,
  maybeContext?: unknown,
): ReloadFormStackContext | undefined {
  if (isReloadFormStackContext(maybeContext)) return maybeContext
  if (isReloadFormStackContext(dataOrContext)) return dataOrContext
  return undefined
}
